import { c as _c } from "react/compiler-runtime";
import { forwardRef } from "react";

/**
 * @typedef {import("react").ButtonHTMLAttributes<HTMLButtonElement> & {
 *   destructive?: boolean
 * }} DialogActionProps
 */

/** Text action for Modal footers. Use type="submit" explicitly for form saves. */
const DialogAction = forwardRef(
/**
 * @param {DialogActionProps} props
 * @param {import("react").ForwardedRef<HTMLButtonElement>} ref
 */
function DialogAction(t0, ref) {
  const $ = _c(12);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      children,
      destructive: t1,
      className: t2,
      type: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const destructive = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const type = t3 === undefined ? "button" : t3;
  const t4 = `rounded-md p-3 font-semibold outline-none transition-colors duration-200 motion-reduce:transition-none focus-visible:ring disabled:pointer-events-none disabled:opacity-50 ${destructive ? "text-red-600 ring-red-500/50 hover:bg-red-500/10 active:bg-red-500/10 dark:text-red-400" : "text-blue-500 ring-blue-500/50 hover:bg-zinc-400/10 active:bg-zinc-400/10 dark:text-white"} ${className}`;
  let t5;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t4 || $[10] !== type) {
    t5 = <button {...props} ref={ref} type={type} className={t4}>{children}</button>;
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t4;
    $[10] = type;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
});
export default DialogAction;